import { getLocation, submitFetch, selectArea, authModal, createResvButtons } from '@/js/components/common'
import { each } from 'jquery'
const token = document.querySelector('meta[name="csrf-token"]').getAttribute('content')
import { stringify } from 'qs'

const setResvAction = (parent) => {
    parent.find('.button.tel-resv, .button.online-resv').on('click', e => {
        e.preventDefault()
        let url = $(e.currentTarget).attr('data-url')
        window.open(url, url.match(/^tel:/) ? '_self' : '_blank')
    })
}
const main = () => {
    if (!document.querySelector('#page-restaurant-search')) return false;
    selectArea()

    $('.cond-gps button').on('click', async e => {
        e.preventDefault()
        $(e.currentTarget).prop('disabled', true)
        let pos = await getLocation()
            .catch(() => {
                alert('位置情報を取得できませんでした。')
            }).finally(() => {
                $(e.currentTarget).prop('disabled', false)
            })
        if (pos) {
            location.href = `/restaurant?gps[lat]=${pos.coords.latitude}&gps[lng]=${pos.coords.longitude}`
        }
        return false
    })

    $('.sp-search').on('click', () => {
        if ($('.search-cond').hasClass('open')) {
            $('.search-cond').removeClass('open')
        } else {
            $('.search-cond').addClass('open')
        }
    })

    $('.search-cond > .close').on('click', e => {
        $('.search-cond').removeClass('open')
    })

    $('.render-cond .delete').on('click', e => {
        $(e.currentTarget).closest('li').remove()
        let params = {}
        $('.render-cond li').each((idx, obj) => {
            let key = $(obj).attr('data-key')
            let value = $(obj).attr('data-value')

            if (key in params) {
                params[key].push(value)
            } else {
                params[key] = [value]
            }
        })

        let query = stringify(params)

        location.href = query ? `/restaurant?${query}` : '/restaurant'
    })

    $('.reserve-buttons .button.approval').on('click', async (e) => {
        e.preventDefault()
        const stage = $(e.currentTarget).attr('data-stage')
        const encrypt = $(e.currentTarget).attr('data-encrypt')
        let resp = await authModal(stage, { token, encrypt })
            .catch((e) => {
                throw e;
            })
        if (resp.success) {
            sessionStorage.setItem(`resv_${stage}_key`, resp.password);
            $('.reserve-buttons .button.approval').each((i, obj) => {
                const parent = $(obj).parent()
                const encrypt = $(obj).attr('data-encrypt')
                if (!encrypt) return true;
                createResvButtons(encrypt, resp.password, parent, 'button')
                setResvAction(parent)
            });
        }
    });

    $('.reserve-buttons').each((i, obj) => {
        setResvAction($(obj))
    });

    const authStage = $('main').attr('data-auth-stage');
    let authPassword;

    switch (authStage) {
        case 'premium':
            authPassword = sessionStorage.getItem("resv_premium_key")
            break;
        case 'member':
            authPassword = sessionStorage.getItem("resv_member_key")
            break;
    }
    if (authPassword) {
        $('.reserve-buttons .button.approval').each((i, obj) => {
            const parent = $(obj).parent()
            const encrypt = $(obj).attr('data-encrypt')
            createResvButtons(encrypt, authPassword, parent, 'button')
            setResvAction(parent)
            console.log(parent)
        });
    }
}
export default main;